import graphql__f31584c4da3cdddbcd55 from "./__generated__/FeaturedContentBlock_block.graphql.js";import { graphql, useFragment } from "react-relay";

import FeaturedContentBlockText from "./FeaturedContentBlockText";
import FeaturedContentBlockImage from "./FeaturedContentBlockImage";
import { hasHtmlContent } from "../Utils/htmlStringUtils";

const displayModeComponents = {
  text: FeaturedContentBlockText,
  image: FeaturedContentBlockImage
};

const FeaturedContentBlock = props => {
  const block = useFragment(FeaturedContentBlock_block, props.block);
  const { title } = block;

  const displayMode = hasHtmlContent(title) ? "text" : "image";
  const DisplayModeComponent = displayModeComponents[displayMode];

  return (
    <li className="content-block list-unstyled">
      <DisplayModeComponent block={block} />
    </li>
  );
};

const FeaturedContentBlock_block = graphql__f31584c4da3cdddbcd55;

export default FeaturedContentBlock;
